import { FieldDescription, FieldGroup } from '@azelis/ui/components/field';
import { Tabs } from '@azelis/ui/components/tabs';
import { LoaderCircle } from 'lucide-react';

import { DriveDocumentsColumn } from './drive-documents-column';
import { ProductDocumentsColumn } from './product-documents-column';
import { SelectedDocumentsColumn } from './selected-documents-column';
import { useSubmitWizard } from './submit-wizard-context';
import { useDocumentsStep } from './use-documents-step';

export function DocumentsStep() {
  const { documents, documentsLoading, selectedDocumentIds, toggleDocument, toggleDocuments } =
    useSubmitWizard();
  const {
    grouped,
    drives,
    selectedDrive,
    setSelectedDrive,
    allIds,
    allSelected,
    selectedDriveIds,
    driveAllSelected,
    selectedDocuments,
  } = useDocumentsStep({ documents, selectedDocumentIds, toggleDocument, toggleDocuments });

  if (documentsLoading) {
    return <DocumentsLoadingState />;
  }

  if (drives.length === 0) {
    return <NoDocumentsFoundState />;
  }

  return (
    <Tabs
      className="w-full gap-6 py-8"
      orientation="vertical"
      value={selectedDrive}
      onValueChange={(drive) => {
        if (drive) {
          setSelectedDrive(drive);
        }
      }}
    >
      <div className="flex w-full items-start justify-between gap-6">
        <ProductDocumentsColumn
          allIds={allIds}
          allSelected={allSelected}
          drives={drives}
          grouped={grouped}
          onToggleAll={toggleDocuments}
        />
        <DriveDocumentsColumn
          driveAllSelected={driveAllSelected}
          drives={drives}
          grouped={grouped}
          selectedDocumentIds={selectedDocumentIds}
          selectedDriveIds={selectedDriveIds}
          onToggleDocument={toggleDocument}
          onToggleDriveAll={toggleDocuments}
        />
        <SelectedDocumentsColumn selectedDocuments={selectedDocuments} />
      </div>
    </Tabs>
  );
}

function DocumentsLoadingState() {
  return (
    <FieldGroup className="w-full items-center py-8">
      <FieldDescription className="flex items-center gap-2">
        <LoaderCircle aria-hidden className="size-4 animate-spin text-muted-foreground" />
        Loading documents…
      </FieldDescription>
    </FieldGroup>
  );
}

function NoDocumentsFoundState() {
  return (
    <FieldGroup className="w-full py-8">
      <FieldDescription>No matching documents found for this product.</FieldDescription>
    </FieldGroup>
  );
}
